var _path, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProdType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0474 12.7961H23.313C26.8036 12.7961 29.6365 15.7135 29.6365 19.2923V26.4499C29.6365 30.0287 26.8036 32.9332 23.313 32.9332H11.3235C7.83295 32.9332 5 30.0287 5 26.4499V19.2923C5 15.7135 7.83295 12.7961 11.3235 12.7961H11.5891C11.6144 11.2401 12.2088 9.78782 13.2838 8.69862C14.3715 7.59646 15.7627 7.0389 17.3309 7C20.4674 7 23.0095 9.59332 23.0474 12.7961ZM14.612 10.0854C13.9038 10.8115 13.5117 11.771 13.4864 12.7954H21.1505C21.1126 10.6688 19.4179 8.94429 17.3311 8.94429C16.3573 8.94429 15.3455 9.34626 14.612 10.0854Z",
    fill: "url(#paint0_linear_2916_19404)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_2916_19404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0549 29.2656L20.5349 29.2656C22.8854 29.2656 24.2539 28.1396 24.2539 26.2102L24.2539 19.6754C24.2539 17.7143 22.8854 16.6136 20.5349 16.6136L14.0549 16.6136C11.6665 16.6136 10.3366 17.7143 10.3366 19.6754L10.3366 26.2102C10.3366 28.1396 11.6665 29.2656 14.0549 29.2656Z",
    fill: "#FA452D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_2916_19404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5227 16.8332C35.5274 16.9477 35.4668 19.2805 35.4199 19.3851H33.2985C33.2575 19.2788 33.2357 16.5891 33.2343 16.4751C33.2343 13.6447 30.9318 11.3502 28.0917 11.3502C25.2515 11.3502 22.949 13.6447 22.949 16.4751C22.9685 16.5853 22.9685 19.2749 22.9491 19.3851H20.7763C20.7569 19.2749 20.7568 16.5853 20.7763 16.4751C20.9414 12.5363 24.1936 9.42773 28.1495 9.42773C32.1054 9.42773 35.3576 12.5363 35.5227 16.4751V16.8332Z",
    fill: "url(#paint1_linear_2916_19404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4226 16.8332H35.4227V16.4772C35.2588 12.5932 32.0514 9.52773 28.1495 9.52773C24.2469 9.52773 21.039 12.5943 20.8762 16.4793L20.8756 16.4927L20.8748 16.4925C20.8748 16.4927 20.8748 16.4932 20.8747 16.4939C20.8744 16.4976 20.8736 16.5081 20.8728 16.5289C20.8718 16.5537 20.8708 16.5875 20.8699 16.6294C20.8681 16.7131 20.8666 16.8272 20.8653 16.9617C20.8629 17.2307 20.8617 17.5803 20.8617 17.9301C20.8617 18.2799 20.8629 18.6296 20.8654 18.8985C20.8666 19.0331 20.8681 19.1471 20.8699 19.2308C20.8703 19.2508 20.8708 19.2689 20.8712 19.2851H22.8541C22.8546 19.2689 22.855 19.2508 22.8555 19.2308C22.8573 19.1471 22.8588 19.0331 22.86 18.8985C22.8624 18.6296 22.8637 18.2799 22.8637 17.9301C22.8636 17.5803 22.8624 17.2307 22.86 16.9617C22.8588 16.8272 22.8573 16.7131 22.8555 16.6294C22.8545 16.5875 22.8536 16.5537 22.8526 16.5289C22.8517 16.5081 22.8509 16.4976 22.8506 16.4939C22.8505 16.4926 22.8505 16.4922 22.8506 16.4925L22.849 16.4839V16.4751C22.849 13.5891 25.1966 11.2502 28.0917 11.2502C30.9865 11.2502 33.334 13.5888 33.3343 16.4746M35.4226 16.8332L33.2343 16.4751M35.4226 16.8332L35.4228 16.8373C35.4249 16.8897 35.4112 17.4963 35.3907 18.1095C35.3805 18.4146 35.3687 18.7189 35.3565 18.9532C35.3504 19.0704 35.3443 19.1694 35.3383 19.2419C35.337 19.2578 35.3357 19.2722 35.3344 19.2851M35.4226 16.8332L35.3344 19.2851M33.3343 16.4746C33.3343 16.4747 33.3343 16.4749 33.3343 16.4751H33.2343M33.3343 16.4746C33.3343 16.4743 33.3343 16.4741 33.3343 16.4739L33.2343 16.4751M33.3343 16.4746C33.3344 16.4852 33.3347 16.514 33.3351 16.558C33.3371 16.7736 33.3426 17.3524 33.3515 17.9314C33.3569 18.2813 33.3635 18.6305 33.3713 18.8987C33.3752 19.0329 33.3794 19.1461 33.3839 19.2288C33.385 19.2498 33.3862 19.2686 33.3873 19.2851M33.2343 16.4751C33.2344 16.4849 33.2347 16.5137 33.2351 16.5582C33.2396 17.032 33.261 19.2879 33.2985 19.3851M33.3873 19.2851H33.2985V19.3851M33.3873 19.2851H35.3344M33.3873 19.2851C33.3884 19.3012 33.3895 19.3151 33.3906 19.3268C33.3917 19.3386 33.3928 19.3471 33.3936 19.3527C33.3943 19.3569 33.3946 19.358 33.3943 19.3569C33.3941 19.3559 33.3933 19.353 33.3918 19.3491L33.2985 19.3851M33.2985 19.3851L35.3344 19.2851",
    stroke: "url(#paint2_linear_2916_19404)",
    strokeOpacity: 0.5,
    strokeWidth: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_2916_19404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7617 24.8134C12.7617 20.3046 16.3309 16.6289 20.7286 16.6289H35.8338C40.2315 16.6289 43.8007 20.3046 43.8007 24.8134V33.831C43.8007 38.3398 40.2315 41.9992 35.8338 41.9992H20.7286C16.3309 41.9992 12.7617 38.3398 12.7617 33.831V24.8134Z",
    fill: "#FEB9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7286 16.1289C16.0418 16.1289 12.2617 20.0416 12.2617 24.8134V33.831C12.2617 38.6041 16.043 42.4992 20.7286 42.4992H35.8338C40.5193 42.4992 44.3007 38.6041 44.3007 33.831V24.8134C44.3007 20.0416 40.5206 16.1289 35.8338 16.1289H20.7286Z",
    stroke: "url(#paint3_linear_2916_19404)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_2916_19404)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_2916_19404",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0857 23.7751C22.7549 23.7751 23.2807 23.2197 23.2807 22.5499V20.6549C23.2807 19.9851 22.7549 19.4297 22.0857 19.4297C21.4324 19.4297 20.8906 19.9851 20.8906 20.6549V22.5499C20.8906 23.2197 21.4324 23.7751 22.0857 23.7751ZM34.339 23.7753C35.0082 23.7753 35.534 23.2198 35.534 22.55V20.655C35.534 19.9852 35.0082 19.4298 34.339 19.4298C33.6857 19.4298 33.1439 19.9852 33.1439 20.655V22.55C33.1439 23.2198 33.6857 23.7753 34.339 23.7753Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0857 23.7751C22.7549 23.7751 23.2807 23.2197 23.2807 22.5499V20.6549C23.2807 19.9851 22.7549 19.4297 22.0857 19.4297C21.4324 19.4297 20.8906 19.9851 20.8906 20.6549V22.5499C20.8906 23.2197 21.4324 23.7751 22.0857 23.7751ZM34.339 23.7753C35.0082 23.7753 35.534 23.2198 35.534 22.55V20.655C35.534 19.9852 35.0082 19.4298 34.339 19.4298C33.6857 19.4298 33.1439 19.9852 33.1439 20.655V22.55C33.1439 23.2198 33.6857 23.7753 34.339 23.7753Z",
    fill: "url(#paint4_linear_2916_19404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0807 22.5499C23.0807 23.1157 22.638 23.5751 22.0857 23.5751V23.9751C22.8717 23.9751 23.4807 23.3237 23.4807 22.5499H23.0807ZM23.0807 20.6549V22.5499H23.4807V20.6549H23.0807ZM22.0857 19.6297C22.638 19.6297 23.0807 20.0891 23.0807 20.6549H23.4807C23.4807 19.8812 22.8717 19.2297 22.0857 19.2297V19.6297ZM21.0906 20.6549C21.0906 20.0908 21.5475 19.6297 22.0857 19.6297V19.2297C21.3172 19.2297 20.6906 19.8794 20.6906 20.6549H21.0906ZM21.0906 22.5499V20.6549H20.6906V22.5499H21.0906ZM22.0857 23.5751C21.5475 23.5751 21.0906 23.114 21.0906 22.5499H20.6906C20.6906 23.3254 21.3172 23.9751 22.0857 23.9751V23.5751ZM35.334 22.55C35.334 23.1159 34.8913 23.5753 34.339 23.5753V23.9753C35.125 23.9753 35.734 23.3238 35.734 22.55H35.334ZM35.334 20.655V22.55H35.734V20.655H35.334ZM34.339 19.6298C34.8913 19.6298 35.334 20.0892 35.334 20.655H35.734C35.734 19.8813 35.125 19.2298 34.339 19.2298V19.6298ZM33.3439 20.655C33.3439 20.091 33.8008 19.6298 34.339 19.6298V19.2298C33.5705 19.2298 32.9439 19.8795 32.9439 20.655H33.3439ZM33.3439 22.55V20.655H32.9439V22.55H33.3439ZM34.339 23.5753C33.8008 23.5753 33.3439 23.1141 33.3439 22.55H32.9439C32.9439 23.3255 33.5705 23.9753 34.339 23.9753V23.5753Z",
    fill: "url(#paint5_linear_2916_19404)",
    fillOpacity: 0.5,
    mask: "url(#path-7-inside-1_2916_19404)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2916_19404",
    x: -6.66406,
    y: -0.386719,
    width: 47.918,
    height: 46.6523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_2916_19404"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_2916_19404",
    x: 5.76172,
    y: -5.57227,
    width: 44.7617,
    height: 39.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2916_19404"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.447059 0 0 0 0 0.368627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2916_19404",
    result: "effect2_dropShadow_2916_19404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2916_19404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_2916_19404",
    x: -3.23828,
    y: 0.628906,
    width: 63.0391,
    height: 57.3711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2916_19404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2916_19404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_2916_19404",
    x: 5.89062,
    y: 4.42969,
    width: 44.6445,
    height: 34.3457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2916_19404"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.447059 0 0 0 0 0.368627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2916_19404",
    result: "effect2_dropShadow_2916_19404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2916_19404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2916_19404",
    x1: 19.132,
    y1: 21.7032,
    x2: -2.92711,
    y2: 31.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F23E2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2916_19404",
    x1: 34.4764,
    y1: 11.2258,
    x2: 18.0547,
    y2: 12.0196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2916_19404",
    x1: 34.8905,
    y1: 14.617,
    x2: 20.569,
    y2: 15.5015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2916_19404",
    x1: 17.7026,
    y1: 19.5846,
    x2: 32.9243,
    y2: 42.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2916_19404",
    x1: 34.4959,
    y1: 20.2144,
    x2: 18.3618,
    y2: 21.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2916_19404",
    x1: 34.9067,
    y1: 21.6944,
    x2: 20.9209,
    y2: 23.6578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdType);
export default __webpack_public_path__ + "static/media/ProdType.0143c27048cdaa3c16f25ffdf4806397.svg";
export { ForwardRef as ReactComponent };